import { render, staticRenderFns } from "./Merge.vue?vue&type=template&id=e125d128&scoped=true"
import script from "./Merge.vue?vue&type=script&lang=js"
export * from "./Merge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e125d128",
  null
  
)

export default component.exports